<template>
    <v-dialog max-width="720px" v-model="getModalCadastroPermissao">
        <v-card outlined :loading="$store.getters.getOverlay">
            <Alert />
            <v-card-title>
                Cadastro de Permissão
            </v-card-title>
            <v-form ref="form" class="px-3">
                <v-card-text>
                    <v-layout row wrap class="">
                        <v-flex xs12 md12>
                            <v-autocomplete :items="getGruposPermissoes" label="Grupo" item-text="nome" item-value="id"
                                v-model="getPermissao.grupo_id" class="ml-2 mr-2" outlined dense append-outer-icon="control_point"
                                @click:append-outer="cadastrarGrupoPermissao"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field dense label="Permissão" class="ml-2 mr-2" outlined
                                v-model="getPermissao.permissao" :rules="rules.permissao"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field dense label="Descrição" class="ml-2 mr-2" outlined
                                v-model="getPermissao.descricao" :rules="rules.descricao" @keyup.13="salvar">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" @click="salvar" outlined :loading="$store.getters.getOverlay">Salvar</v-btn>
                    <v-btn v-if="getPermissao.id" color="primary" @click="cadastrarPermissao" outlined>Novo</v-btn>
                    <v-btn v-if="getPermissao.id" color="error" @click.stop="setModalExcluirPermissao(true)" outlined>
                        Excluir</v-btn>
                    <v-btn class="white--text" color="blue-grey" @click="setModalCadastroPermissao(false)" outlined>
                        Voltar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>

        <ModalExcluirPermissao />
        <ModalCadastroGrupoPermissao />
    </v-dialog>
</template>

<script>
    import ModalExcluirPermissao from "@/pages/perfil/permissao/ModalExcluir"
    import ModalCadastroGrupoPermissao from '@/pages/perfil/grupoPermissao/ModalCadastro'
    import { mapGetters, mapActions } from 'vuex'
    export default {
        components: {
            ModalExcluirPermissao,
            ModalCadastroGrupoPermissao
        },
        data() {
            return {
                rules: {
                    permissao: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    descricao: [
                        v => !!v || 'Campo obrigatório.'
                    ]
                }
            }
        },
        computed: {
            ...mapGetters([
                'getPermissao',
                'getModalCadastroPermissao',
                'getGruposPermissoes'
            ])
        },
        methods: {
            ...mapActions([
                'setModalCadastroPermissao',
                'setModalExcluirPermissao',
                'cadastrarPermissao',
                'salvarPermissao',
                'atualizarPermissao',
                'listarGrupoPermissao',
                'cadastrarGrupoPermissao'
            ]),
            salvar() {
                if (this.$refs.form.validate()) {
                    if (this.getPermissao.id) {
                        this.atualizarPermissao(this.getPermissao)
                    } else {
                        this.salvarPermissao(this.getPermissao)
                    }
                }

            },
        },
        created() {
            this.listarGrupoPermissao()
        }
    }
</script>